import { render, staticRenderFns } from "./FincaSelectItem.vue?vue&type=template&id=601856ac"
import script from "./FincaSelectItem.vue?vue&type=script&lang=js"
export * from "./FincaSelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports